import { onError } from "@apollo/client/link/error";
import React, { useEffect } from "react";
import useSound from "use-sound";

import { usePushNotification } from "./hooks/usePushNotification";
import Routes from "./pages";

const App = React.memo(() => {
    const [play, { stop }] = useSound("/silence.mp3");
    const { init: initPushNotification } = usePushNotification();

    useEffect(() => {
        initPushNotification();
    }, [initPushNotification]);

    useEffect(() => {
        play();
    }, [play]);

    return (
        <>
            <Routes />
        </>
    );
});

export default App;
